<template>
  <v-container fluid fill-height grid-list-md text-xs-center>
    <v-layout wrap align-center justify-center fill-height>
      <v-flex xs12 md3>
        <v-layout justify-center class="pa-3">
          <v-img :src="this.logoUrl" width="200" v-if="!!this.logoUrl"></v-img>
          <h1 v-else class="text-xs-center" :style="`font-size: 45px; color: ${ logoColor }`">{{ this.company }}</h1>
        </v-layout>
      </v-flex>

      <v-flex xs12 md3>
        <h1>{{ $t('signup') }}</h1>
        <v-form @submit.prevent="submit">
          <template v-if="stepOneVisible">
            <v-text-field v-model="user.name"
                          name="name"
                          :label="$t('attrs.name')"
                          v-validate="'required'"
                          :error-messages="errors.collect('name')"
                          data-vv-name="name"
                          :data-vv-as="$t('attrs.name')"
                          required
                          ></v-text-field>

            <v-text-field v-model="user.last_name"
                          name="last_name"
                          :label="$t('attrs.last_name')"
                          v-validate="'required'"
                          :error-messages="errors.collect('last_name')"
                          data-vv-name="last_name"
                          :data-vv-as="$t('attrs.last_name')"
                          required
                          ></v-text-field>

            <v-text-field v-model="user.email"
                          name="email"
                          :label="$t('attrs.email')"
                          v-validate="'required|email'"
                          :error-messages="errors.collect('email')"
                          data-vv-name="email"
                          :data-vv-as="$t('attrs.email')"
                          required
                          ></v-text-field>

            <v-text-field v-model="user.password"
                          name="password"
                          :label="$t('attrs.password')"
                          v-validate="'required'"
                          :error-messages="errors.collect('password')"
                          data-vv-name="password"
                          :data-vv-as="$t('attrs.password')"
                          required
                          type="password"
                          ></v-text-field>

            <v-text-field v-model="user.phone"
                          name="phone"
                          :label="$t('attrs.phone')"
                          v-validate="'required|max:10'"
                          :error-messages="errors.collect('phone')"
                          data-vv-name="phone"
                          :data-vv-as="$t('attrs.phone')"
                          required
                          ></v-text-field>

            <v-text-field v-model="user.company"
                          name="company"
                          :label="$t('attrs.company')"
                          ></v-text-field>

            <v-text-field v-model="user.referred_by"
                          name="referred_by"
                          :label="`${$t('attrs.referral_code')} (${$t('optional')})`"
                          v-if="showReferralCode"
                          ></v-text-field>

            <v-btn block color="primary" type="button" @click="stepTwoForm">{{ $t('save') }}</v-btn>
          </template>

          <template v-else>
            <div style="text-align: left">
              <v-btn color="primary" flat icon @click="goToFirst">
                <font-awesome-icon icon="arrow-left" size="2x"></font-awesome-icon>
              </v-btn>
            </div>
            <span v-for="question in user.questions" :key="question.id">
              <v-select v-model="question.answer"
                            :items="question.options"
                            item-value=""
                            item-text=""
                            :label="question.question"
                            ></v-select>
            </span>
            <v-btn block color="primary" :loading="loading" @click="createAccount()">{{ $t('attrs.createAccount') }}</v-btn>
          </template>

          <a @click="goTo('login')">{{ $t('login') }}</a><br>
          <a style="cursor: default">{{ $t('acceptTermsAndConditions') }}</a><br>
          <a :href="termsAndConditions.value" target="_blank" v-if="hasTermsAndConditions">{{ $t('termsAndConditions') }}</a>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Registration from '@/client/registration'
import Setting from '@/client/setting'
import VeeValidate from 'vee-validate';


export default {
  name: 'SignupView',

  props: {},

  data () {
    return {
      loading: false,
      user: {},
      ref: null,
      referralSetting: {},
      termsAndConditions: {},
      stepOneVisible: true,
      questions: [
        { question: this.$t('questions.numberOfShipmentsPerMonth'),
          options: [
            this.$t('answers.noShips'),
            `1-20 ${this.$tc('models.shipment', 2)}`,
            `21-50 ${this.$tc('models.shipment', 2)}`,
            `51-100 ${this.$tc('models.shipment', 2)}`,
            `101-200 ${this.$tc('models.shipment', 2)}`,
            `201-500 ${this.$tc('models.shipment', 2)}`,
            `501-1000 ${this.$tc('models.shipment', 2)}`
          ],
          answer: ''
        },
        { question: this.$t('questions.typeOfBusiness'),
          options: [
            this.$t('answers.noBusiness'),
            this.$t('answers.startingBusiness'),
            this.$t('answers.vendor'),
            this.$t('answers.eCommerce'),
            this.$t('answers.provider')
          ],
          answer: ''
        },
        { question: this.$t('questions.howWeHelp'),
          options: [
            this.$t('answers.getStarted'),
            'API',
            this.$t('answers.guides'),
            this.$t('answers.integration'),
            this.$t('answers.other')
          ],
          answer: ''
        }
      ],
      createAccountClicked: false,
      logoColor: process.env.VUE_APP_COLOR
    }
  },

  components: {
  },

  computed: {
    showReferralCode () {
      return this.referralSetting.value === '1'
    },

    hasTermsAndConditions () {
      return !!(this.termsAndConditions || {}).value
    },
  },

  methods: {
    async stepTwoForm () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }

      this.stepOneVisible = false
    },

    async submit () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }

      if (this.user.questions[0].answer == '' || !this.createAccountClicked) { return }

      this.loading = true
      try {
        if (!this.user.referred_by) {
          this.user.referred_by = undefined
        }

        await this.user.save()
        this.setNotification({ color: 'success', message: this.$t('registrationSuccessfully') })
        this.back()
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    },

    goToFirst () {
      this.stepOneVisible = true
      this.createAccountClicked = false
    },

    createAccount () {
      this.createAccountClicked = true
      if (this.createAccountClicked) this.submit()
    }
  },

  watch: {
  },

  async mounted () {
    this.user = new Registration()
    this.referralSetting = await Setting.byKey('referral_code')
    this.ref = this.$route.query.ref
    this.user.referred_by = this.ref
    this.termsAndConditions = await Setting.byKey('terms_conditions')
    this.user.questions = this.questions
    const email = {
      getMessage: () => this.$t('invalidEmail'),
      validate(value) {
        const EMAILREG = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
        return EMAILREG.test(value);
      }
    };

    VeeValidate.Validator.extend('email', email);
  }
}
</script>
